<div class="toasts-wrapper-inner">
  @for (toast of toasts; track toast.id) {
    <div
      id="{{ toast.id }}"
      class="toast toast-{{ toast.type }} fade show"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      (mouseenter)="pauseAllToastTimers()"
      (mouseleave)="onMouseLeave()"
    >
      <div class="d-flex">
        <div class="toast-body">
          @if (toast.title) {
            <p>
              <strong>{{ toast.title }}</strong> - {{ toast.content }}
            </p>
          } @else {
            <p>{{ toast.content }}</p>
          }
          @if (toast.actionFn && toast.actionBtnLabel) {
            <button class="btn btn-xs" (click)="toast.actionCallback()">
              {{ toast.actionBtnLabel }}
            </button>
          }
        </div>
        @if (toast.hideTimer) {
          <button class="btn-close with-timer" (click)="killToast(toast.id)">
            <svg class="progress-ring" width="32" height="32">
              <circle
                class="progress-ring__circle"
                stroke="#9e9e9e"
                stroke-width="2"
                fill="transparent"
                [attr.r]="radius"
                [attr.cx]="center"
                [attr.cy]="center"
                [attr.stroke-dasharray]="circumference"
                [attr.stroke-dashoffset]="
                  circumference *
                  (1 -
                    (toast.hideTimer.remainingMs() | calcPercent: toast.hideTimer.savedDelay) / 100)
                "
              />
            </svg>
          </button>
        } @else {
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="killToast(toast.id)"
          ></button>
        }
      </div>
    </div>
  }
</div>
